import dayjs, { type Dayjs } from "dayjs"

const API_TIME = "YYYY-MM-DD HH:mm:ss"

/** The API writes times in UTC with no zone marker; `dayjs(value)` would read them as local. */
export const parseApiTime = (
  value: string | null | undefined
): Dayjs | null => {
  if (!value) return null
  const parsed = dayjs.utc(value, API_TIME, true)
  return parsed.isValid() ? parsed : null
}

export const secondsBetween = (
  from: string | Dayjs | null | undefined,
  to: string | Dayjs | null | undefined
): number | null => {
  const start =
    typeof from === "string" || !from
      ? parseApiTime(from as string | null)
      : from
  const end =
    typeof to === "string" || !to ? parseApiTime(to as string | null) : to
  if (!start || !end) return null
  return end.diff(start, "second")
}

/** Where a request's clocks stop: when it ended, or now while it still runs. */
export const requestClock = (endedAt: string | null | undefined): Dayjs =>
  parseApiTime(endedAt) ?? dayjs.utc()
